import Info from 'components/shared/Info'
import Link from 'components/shared/Link'
import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'

interface BungalowEquipmentInfoBoxProps {
    modalOpener: () => void
    index: number
}

export const BungalowEquipmentInfoBox = ({
    modalOpener,
    index,
}: BungalowEquipmentInfoBoxProps) => (
    <Info color="info_warning" align="flex-start">
        <>
            <Box mb={24}>
                <FormattedMessage
                    id="accommodation.plan_your_stay.bungalow_equipment_info_box_text"
                    defaultMessage="Wszystkie bungalowy mają takie samo wyposażenie – różnią się jedynie konfiguracją łóżek."
                />
            </Box>
            <Link
                variant="secondary"
                icon={null}
                onClick={modalOpener}
                data-testid={`accommo-${index}-see-more`}
            >
                <Text variant="bodySmall" as="span">
                    <FormattedMessage
                        id="accommodation.plan_your_stay.bungalow_equipment_info_box_link"
                        defaultMessage="Zobacz nasze bungalowy"
                    />
                </Text>
            </Link>
        </>
    </Info>
)

export default BungalowEquipmentInfoBox
